// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h1[data-v-ee6586ee]{color:#6a767d;text-align:center;font-size:24px;line-height:29px}@media(min-width:768px){h1[data-v-ee6586ee]{font-size:48px;line-height:59px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
